import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints';

export async function getFormPossibleGroups(businessUnit, carLot, branchOffice){
    let possibleGroupsResponse = await axios.get(`${LEADS_ENDPOINT}/form/possibleGroups/?businessUnit=${businessUnit}&carLot=${carLot}&branchOffice=${branchOffice}`)
    
    return possibleGroupsResponse?.data?.data
}